<template>
  <div class="container">
    <div class="job-list">
      <van-empty v-show="showEmpty">
        暂无收藏职位
        <template #image>
          <img class="empty-image" src="../../../assets/images/common/empty.png" alt="no-jobs">
        </template>
      </van-empty>
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="jobList.length!==0 ? finishedText : ''"
        :error.sync="error"
        :error-text="errorText"
        loading-text="加载中..."
        @load="onGetMore"
      >
        <div
          v-for="(job, i) in jobList"
          :key="i"
          class="job-card"
          :class="[job.status==='Offline' ? 'job-card-end' : '']"
          @click="toDetail(job.position_id)">
          <div class="top">
            <div class="job-title ellipsis line1">{{job.name}}</div>
            <div class="time">{{ job.collection_date}}</div>
          </div>
          <div class="labels">
            <div class="label">{{ job.work_city }}</div>
            <div class="label">{{ job.education | educationText}}</div>
            <div class="label">{{ job.work_type | workTypeText}}</div>
            <van-tag v-if="job.status==='Online'" class="top-right-content-underway">进行中</van-tag>
            <van-tag v-if="job.status==='Offline'" class="top-right-content-end">停止招聘</van-tag>
          </div>
        </div>

      </van-list>
    </div>
  </div>
</template>

<script>
import cookies from "@/libs/util.cookies";
import util from "../../../libs/util";
export default {
  name: "JobCollect",
  data() {
    return {
      errorText: "网络开小差了，点击重新加载",
      error: false,
      jobList: [],
      loading: false,
      finished: false,
      listPage: 1,
      user_id: cookies.get("uid"),
    };
  },
  computed: {
    jobType() {
      return this.$route.meta.type;
    },
    showEmpty() {
      return !this.error && !this.loading && this.jobList.length === 0;
    },    
    finishedText() {
      return this.jobList.length === 0 ? "" : "— 到底咯！—";
    },
  },
  watch: {},
  created() {
    const shareParam = {
      title: "卫宁健康期待您的加入",
      desc: "正在热招",
      link:  process.env.VUE_APP_BASEURL+ '#/',
      imgUrl: process.env.VUE_APP_SHARE_IMG_URL
    }
    util.initWXSdk(shareParam)
  },
  mounted() {
    this.getCollectionList();
  },
  methods: {
    // 获取更多数据
    onGetMore() {
      // 分页更新
      this.listPage += 1;
      this.getCollectionList();
    },

    getCollectionList() {
      this.$api
        .POSITION_COLLECTION_LIST({
          user_id: this.user_id,
          page: this.listPage,
          size: 10,
        })
        .then((res) => {
          this.jobList = this.jobList.concat(res.content);
          // 数据全部加载完成
          if (res.total <= this.listPage * 10) {
            this.finished = true;
          }
          this.error = false;
        })
        .catch(() => {
          this.error = true;
          this.listPage -= 1;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toDetail(jobId) {
      this.$router.push({
        name: "JobDetail",
        params: {
          jobId: jobId,
        },
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: calc(100vh - 54px);
  overflow-y: scroll;
  margin-top: 10px;
}

.job-card {
  margin: 0px 20px;
  padding: 13px 0 15px 0;
  border-bottom: 0.5px solid #f1f4f6;
  background: #ffffff;
  border-radius: 4px;
}

.job-card-end {
  opacity: 0.5;
}

.job-card .top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.job-card .job-title {
  color: #333333;
  font-size: 18px;
  font-weight: bold;
  margin-right: 15px;
}

.job-card .time {
  color: #999999;
  font-size: 12px;
  min-width: 65px;
}

.job-card .labels {
  display: flex;
}

.job-card .label {
  height: 20px;
  padding: 1px 8px 2px 8px;
  margin-right: 5px;
  font-size: 12px;
  color: #999999;
  background: #f1f4f6;
  border-radius: 4px;
}

.job-card .label:nth-child(1) {
  max-width: 130px;
}
.job-card .top-right-content-underway {
  margin-left: auto;
  width: 52px;
  height: 22px;
  background: linear-gradient(90deg, #ff9900 0%, #ff8d19 24%, #fe6868 100%);
  border-radius: 4px;
  font-size: 12px;
  text-align: center;
  color: #ffffff;
}

.job-card .top-right-content-end {
  margin-left: auto;
  width: 52px;
  height: 22px;
  background: linear-gradient(270deg, #e4e4e4 0%, #f0f0f0 100%);
  border-radius: 4px;
  font-size: 12px;
  text-align: center;
  color: #666666;
}

::v-deep {
  .van-list__finished-text {
    color: #cccccc;
  }
}
</style>

